/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { UserModel } from '../../../../app/pages/auth/models/UserModel'
import { RootState } from '../../../../setup'
import * as auth from '../../../../app/pages/auth/redux/AuthRedux'
import { Languages } from './Languages'
import { useDispatch } from 'react-redux'
import { toAbsoluteUrl } from '../../../helpers'
import { useHistory } from 'react-router-dom'
import { updateOtpValidity } from '../../../../app/pages/auth/redux/AuthCRUD'

const HeaderUserMenu: FC = () => {
  const user: UserModel = useSelector<RootState>(({ auth }: any) => auth.user, shallowEqual) as UserModel
  const rights: any = useSelector<RootState>(({ auth }: any) => auth.rights, shallowEqual);
  const id: any = useSelector<RootState>(({ search }) => search.companyId, shallowEqual) as any;
  const customerData: any = useSelector<RootState>(({ customer }) => customer.customer, shallowEqual) as any;
  const history = useHistory();
  const dispatch = useDispatch()
  
  const [otpLogin, setOtpLogin] = useState(false)

  useEffect(() => {
    // Check user's otpvalid24h status when component mounts
    if (user?.otpvalid24h) {
      setOtpLogin(true)
    } else {
      setOtpLogin(false)
    }
  }, [user])

  const toggleOtpLogin = async (e: React.MouseEvent | React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation()
    const newStatus = !otpLogin
    try {
      const saltid = user?.saltid;
      const salt = user?.salt;
      
      setOtpLogin(newStatus)

      const body = { id, otp_validity: newStatus, salt, saltid }
      const response = await updateOtpValidity(body)
      
      if (response.data?.code === 1) {
        dispatch(auth.actions.setOtpValidate({otpvalid24h: newStatus}))
      }
    } catch (error) {
      console.error('Failed to update OTP validity:', error)
    }
  }

  const Logout = () => {
    dispatch(auth.actions.logout())
    history.push('/auth/login')
  }

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img style={{ objectFit: 'cover' }}
              alt='Logo'
              src={toAbsoluteUrl('/media/avatars/blank.png')}
            />
          </div>

          <div className='d-flex flex-column'>
            <a className='fw-bold text-muted text-hover-primary fs-7'>
              {
                user?.email
              }
            </a>
          </div>
        </div>
      </div>
      <div className='separator my-2'></div>
      {
        (rights['admin_allsystems'] || rights['admin_ownagentsystems']) &&
        <>
          <div className='menu-item px-5'>
            <a
              href={`https://portal.nexti.de:9090/designer/portal-login/${id}`}
              target="_blank"
              rel="noreferrer"
              className='menu-link px-5'>
              <span className='menu-title position-relative'>
                Designer
                <span className='fs-8 rounded  px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
                  <img
                    className='w-15px h-15px rounded-1 ms-2'
                    src={toAbsoluteUrl('/media/icons/duotune/icons/designer.ico')}
                    alt='metronic'
                  />
                </span>
              </span>
            </a>
          </div>
          {
            customerData?.planningtool &&
            <div className='menu-item px-5'>
              <a
                href={`https://portal.nexti.de:9091/portal-login/${id}`}
                target="_blank"
                rel="noreferrer"
                className='menu-link px-5'>
                <span className='menu-title position-relative'>
                  Planning Tool
                  <span className='fs-8 rounded  px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
                    <img
                      className='w-15px h-15px rounded-1 ms-2'
                      src={toAbsoluteUrl('/media/icons/duotune/icons/calendar.png')}
                      alt='metronic'
                    />
                  </span>
                </span>
              </a>
            </div>
          }
          {
            customerData?.cloudsolo &&
            <div className='menu-item px-5'>
              <a
                href={`http://portal.nexti.de/cloudsolo/portal-login/${id}`}
                target="_blank"
                rel="noreferrer"
                className='menu-link px-5'>
                <span className='menu-title position-relative'>
                  Cloud Solo
                  <span className='fs-8 rounded  px-3 py-2 position-absolute translate-middle-y top-50 end-0'>
                    <img
                      className='w-16px h-15px rounded-1 ms-2'
                      src={toAbsoluteUrl('/media/icons/duotune/icons/cloud.png')}
                      alt='metronic'
                    />
                  </span>
                </span>
              </a>
            </div>
          }
        </>
      }      
      <Languages />
      <div className='menu-item px-5'>
        <div 
          onClick={(e) => toggleOtpLogin(e)} 
          className='menu-link px-5 d-flex justify-content-between align-items-center'
        >
          <span>OTP 24h validity</span>
          <div className={`form-check form-switch`} onClick={(e) => e.stopPropagation()}>
            <input
              className='form-check-input'
              type='checkbox'
              checked={otpLogin}
              onChange={(e) => toggleOtpLogin(e)}
            />
          </div>
        </div>
      </div>
      {rights['superuser'] && (
        <div className='menu-item px-5'>
          {/* !!!Hard Code!!! */}
          {/* Here we need an id because of navigation between pages */}
          <a id='btn_sign_out' onClick={() => history.push(`/maintenance/newcompany/${913}`)} className='menu-link px-5'>
            New Company
          </a>
        </div>
      )}
      <div className='menu-item px-5'>
        <a id='btn_sign_out' onClick={Logout} className='menu-link px-5'>
          Sign Out
        </a>
      </div>
    </div>
  )
}

export { HeaderUserMenu }
